import React, { Suspense, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import ErrorBoundary from "../../Components/ErrorBoundry/ErrorBoundary";
import Footer from "../../Components/Footer/Footer";
import { getAuthState } from "../../Utils/AuthRedirections";
import { AuthState, FORMTOASTERRID, INSTALLATION_MODE, THREE_D_ANALYSIS_PACKAGE_ID, userRole } from "../../Utils/Const";
import { BillingBasis, getPaymentStatus, hasUnconfirmedPayment, PAYMENT_RESULT_ROUTE, paymentErrorMessage, startPayUCheckout, takeCompletedPayment } from "../../lib/payments/payu";
import DefaultHeader from "./DefaultHeader";
import { LoadingSpinner } from "../../Components/AllInput/AllInput";
import DefaultAside from "../../Components/DefaultAside/DefaultAside";
import ReactToolTip from "../../Components/InfoModal/ReactToolTip";
import CustomerDashboardLanding from "../../Screen/Consumer/Dashboard/CustomerDashboardLanding";
import { useAppDispatch, useAppSelector } from "../../ReduxTool/store/hooks";
import { NewModal } from "../../Components/New/Modal/NewModal";
import { switchView } from "../../lib/Customer/SwitchMap";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchBuildingfromCoordinates } from "../../Utils/Fetch3D/fetchRoof";
import { baseURL, EPCRoofAnalysisURLString, requestUrl } from "../../Utils/baseUrls";
import { resetRoofAnalisis, setProject3dAnalysisIframeURL, setSelectedOption } from "../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { ProjectTy } from "../../ReduxTool/Slice/Auth/types";
import Toast from "../../Components/ErrorBoundry/Toast";
import { setButtonLoader, setModalHeaderFooter } from "../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { toast } from "react-toastify";
import { saveConsumerProjects } from "../../ReduxTool/Slice/Consumer/ProjectServices/projectServices";
import { setCardTitle } from "../../ReduxTool/Slice/Dashboard/DashboardReducer";
import { setTitle, toggleDrawer } from "../../ReduxTool/Slice/Drawer/DrawerReducer";
import ConfirmAction from "../../Screen/Consumer/RoofAnalysis/ConfirmActionModal/ConfirmAction";
import { set3dpayment } from "../../ReduxTool/Slice/Payment/paymentReducer";
import ConfirmLead from "../../Screen/Consumer/RoofAnalysis/ConfirmLead/ConfirmLead";
import { LeadSuccessModal, ModeOptionTy } from "./DefaultContainerExtras";
import { convertACtoDC, getCapacityFields } from "../../Utils/commonFunctions";
// import ConfirmAction from "../../Screen/Consumer/RoofAnalysis/ConfirmActionModal/ConfirmAction";

const DefaultContainer = ({ pathname }: { pathname: string }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const [isAnalysis,setIsAnalysis] = useState(false);
  const { user, isState: userLoadState } = useAppSelector((state) => state.auth);
  const isVerifyingAccount = !Object.keys(user ?? {}).length && ["idle", "pending", "accountgone"].includes(userLoadState);
  const [loadingFinalProceed,setLoadingFinalProceed] = useState(false);
  const { projects: newProject, isLoading: loading,roofAnalysis:{selected_project,selectedOption,subsequentOption ,formDetails:{projectSummary,quickplantAnalysis,projectSetup}}, orderModalOpen, orderstatusmodal } = useAppSelector((state) => state.consumerReducers);
  const { title : modalTitle, btnTxt, secondaryBtnTxt,modalid,isheader } = useAppSelector( (state) => state.commonReducers.modal );
  const {is3dpayment} =  useAppSelector(state=>state.payment)

  const [isConfimModal, setIsConfimModal] = useState(false);
  const [proceedToPaymentLoading,setProceedToPaymentLoading] = useState(false);

  const cos_tooltipcontent = {
    env: `A solar plant reduces carbon dioxide emissions through clean energy production. On average, each unit of solar energy prevents 0.7 kg of CO2 emissions and is equivalent to planting of 2 trees. `,
    cost: `The "cost of project" refers to the total expenses associated with planning, designing, procuring materials, installing, and commissioning a solar energy system. `,
    gen: `Total Electricity Generation is the overall amount of electrical energy produced within a specific time period, typically measured in megawatt-hours, reflecting the aggregate output from various power sources. `,
    fin: `Financial savings refer to the surplus or leftover funds that result from reducing expenses or increasing income, leading to a positive difference between income earned and money spent over a specified period. `,
    elec: "Current electricity rate per unit (kWh) as per your selected Discom Provider. You can edit this value if your actual rate differs.",
    user: "Edit user details.",
    manageticketuser: "User details."
  }

  const showMoreToolTip = {
    environmentalTooltip: <p>{cos_tooltipcontent.env}<a className="underline" href="https://terranxt.com/consumer-portal-faq/" target="_blank">Learn More</a></p>,
    costofprojecttooltip: <p>{cos_tooltipcontent.cost}<a className="underline" href="https://terranxt.com/consumer-portal-faq/" target="_blank">Learn More</a></p>,
    totalgenerationtooltip: <p>{cos_tooltipcontent.gen}<a className="underline" href="https://terranxt.com/consumer-portal-faq/" target="_blank">Learn More</a></p>,
    financialsavingstooltip: <p>{cos_tooltipcontent.fin}<a className="underline" href="https://terranxt.com/consumer-portal-faq/" target="_blank">Learn More</a></p>,
    electricityratetooltip: <p>{cos_tooltipcontent.elec} <a className="underline" href="https://terranxt.com/consumer-portal-faq/" target="_blank">Learn More</a></p>,
    userdetailstooltip: <p>{cos_tooltipcontent.user}</p>,
    userdetailstickettooltip: <p>{cos_tooltipcontent.manageticketuser}</p>,
    roofdetailstickettooltip: <p>{"."}</p>,
    projectSummaryTooltip: <p> <a className="underline" href="https://lcoe.pvnxt.com/" target="_blank">Learn More</a></p>,
    approveProposalTooltip: <p><p>Proposal available for approval.</p></p>,
  }

  // PayU's return can land on another site (backend PayU:FrontendResultUrl); when the user comes back to this tab,
  // finish confirming that checkout here so the purchase (e.g. proposal booking) still completes
  useEffect(() => {
    if (hasUnconfirmedPayment()) navigate(PAYMENT_RESULT_ROUTE, { replace: true });
    // Back from PayU can restore this page from the browser's back/forward cache, frozen mid-checkout
    // (loaders spinning, Pay disabled) and without running effects. Reload so the check above runs.
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted && hasUnconfirmedPayment()) window.location.reload();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  useEffect(() => {
    if (user && !loading && user?.projects?.length === 0 && location.pathname !== '/Consumer/welcome') {
      navigate('/Consumer/welcome');
    }
  }, [user]);

  const [show, hide] = useState(false)

  // Back from PayU with a 3D Roof Analysis payment for this project: re-check it with the server, then open
  // the 3D view straight away (as before PayU, when paying opened it directly)
  useEffect(() => {
    const projectId = selected_project?.projectid;
    if (!projectId) return;
    const transactionId = takeCompletedPayment({ type: "3danalysis", projectId });
    if (!transactionId) return;
    (async () => {
      try {
        const payment = await getPaymentStatus(transactionId);
        if (payment.status !== "Success") return;
        dispatch(set3dpayment(true));
        // The result card is skipped for this purchase, so confirm the payment clearly here
        Toast({ messageText: "Payment successful — 3D Roof Analysis is unlocked for this project.", messageType: "S", toastId: "3d-payment-success", autoClose: 7000 });
        await fetchIframeAnalysis("");
      } catch (error) {
        Toast({ messageText: paymentErrorMessage(error), messageType: "E", toastId: FORMTOASTERRID });
      }
    })();
  }, [selected_project?.projectid]);

  const fetchIframeAnalysis = async (btnName:string) => {
  
    dispatch(setButtonLoader(""))
    
    // debugger
    if (btnName === "Cancel") {
      dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "" }));
      dispatch(set3dpayment(false));
      return
    }
    if (is3dpayment != true) {
      dispatch(set3dpayment(true));
    } 
    setIsAnalysis(true)
    handleCloseConfirm()
   
    if (show) {
        await switchView(globalLayers.activeView)
        return
    }
    // else {
    //   hide(true)
    //   await switchView(globalLayers.activeView)
    // }



    // swithc map view to sceneview 

    const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number, selected_project?.graphicLayer);
    // debugger
    if (building) {
        // add shadw cast widget 
        // const shadowCast = new ShadowCast({  
        //   view: globalLayers.view!, // your SceneView
        // });

        // Add widget to top-right corner
        // globalLayers.view?.ui.add(shadowCast, "top-right");

        // const graphic = await fetchChildWMSLayersByParentId_byBaseLayer(globalLayers.selectedRoof.objectid, {});
        // // all the stired graphics in globalLayers.graphic3dLayers 
        // globalLayers.SceneViewLayers = graphic;
        // await switchView(globalLayers.activeView)
        // hide(true)


        // store.dispatch(setReloader(false))
        // await switchView(globalLayers.activeView)


        //open iframe here 
        // 
        // 
        // href={`${EPCRoofAnalysisURLString}/?token=${localStorage.getItem("token")}&userid=${user.userid}&projectid=${data?.buildingid}`}

        const token = localStorage.getItem("token");
        const url = `${EPCRoofAnalysisURLString}/Consumer/RoofAnalysis?token=${token}&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}&usertype=Consumer`;
        // debugger
        dispatch(setProject3dAnalysisIframeURL(url))

        // window.open(url, '_blank');
    } else {
        Toast({ messageText: 'No, 3D roof availabe here', messageType: 'W', toastId: '3d-fecth', autoClose: 3500 })
    }
    setIsAnalysis(false)
    // setAnalysisConfirm(false)
    return
  }  

  const confirmPaymentFor3DAnalysis = async(btnName:string)=>{
    
    if (!selected_project?.projectid) {
      Toast({ messageText: "Save your project before upgrading to 3D analysis.", messageType: "E", toastId: FORMTOASTERRID });
      return
    }
    setProceedToPaymentLoading(true)
    try {
      // Creating the order is not a payment: access is granted only after PayU's verified callback
      // Leaves the app; PayU → backend callback → /payment/result → back to this project
      await startPayUCheckout({
        packageId: THREE_D_ANALYSIS_PACKAGE_ID, featureId: null, billingBasis: BillingBasis.OneTimeProject,
        quantity: 1, projectId: selected_project.projectid, couponCode: null,
      }, location.pathname, { type: "3danalysis", projectId: selected_project.projectid });
    } catch (error) {
      Toast({ messageText: paymentErrorMessage(error), messageType: "E", toastId: FORMTOASTERRID });
      setProceedToPaymentLoading(false)
    }
  }


 const handleModalClick = async (LeadMode: INSTALLATION_MODE) => { // finalizing project modal 
  
             if (LeadMode) {
                 setLoadingFinalProceed(true)
                 if (selected_project && Object.keys(selected_project).length > 0) {
                  
                  let reqBody : any = {} ;
                  // if (!selected_project?.installationmode) {
                  if (!selected_project?.installationmode) {
                      reqBody = {
                         installationmode: LeadMode === undefined ? null : LeadMode,
                         iscompleted: true, // need to complete after payment as new requirement 18-02-2026 
                         consumer_mainprojectstatus: selected_project?.consumer_mainprojectstatus === 0 ? 1 : selected_project?.consumer_mainprojectstatus,
                         userid: user.userid,
                         carbonemission: projectSummary?.financial?.totalCarbonfootprint.toString(),
                         totaltreesplanted: projectSummary?.financial?.totalTrees.toString(),
                         projectcost: quickplantAnalysis.costbracket.toString() === "" ? selected_project?.projectcost?.toString() : quickplantAnalysis.costbracket.toString(),
                         yearlygenusablearea: quickplantAnalysis.electricityGenerated?.toString(),
                         yearlygensanctioned: quickplantAnalysis.electricityGenerated2?.toString(),
                        //  plantcapacity: (convertACtoDC(projectSetup?.sanctionload) ?? "0"),
                         maxplantcapacity: null,
                         ...getCapacityFields(selected_project?.sanctionload, selected_project),
                         consumer_projectstatus: 2,
                         consumer_subprojectstatus: 3,
                         savingperiod : (projectSummary?.degradation?.savingperiod ?? 0) + "",
                         savingirr : Math.floor(projectSummary?.degradation?.irr ?? 0) + "",
                         netsavings : Math.floor(projectSummary?.degradation?.netsavings ?? 0) ,
                         monthlyfinancialsavings : Math.floor(projectSummary?.financial?.montlyFinancialSaving ?? 0) + ""
                     } as any;
                     const consumerDetails = selected_project?.consumerdetails && typeof selected_project.consumerdetails === 'string' ? JSON.parse(selected_project.consumerdetails) : selected_project?.consumerdetails || {};
 
                     if (selected_project && selected_project.consumerdetails) {
                         reqBody.consumerdetails = JSON.stringify({...consumerDetails,...reqBody,});
                     } else {
                         reqBody.consumerdetails = JSON.stringify(reqBody);
                     }
                     }else{
                        reqBody = {
                         installationmode: LeadMode === undefined ? null : LeadMode,
                         ...getCapacityFields(selected_project?.sanctionload, selected_project),}
                     }
                     try {
                      
                       const payload = await dispatch(saveConsumerProjects({ reqBody, projectid: selected_project.projectid }));
                      //  debugger
                        if ((payload as any)?.meta?.requestStatus === "fulfilled") {
                           //  navigate("/Consumer");
                           setLoadingFinalProceed(false)
                           dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
                         
                            if (!selected_project?.installationmode) { 
                           setLeadFinalModal(true)
                           setLeadMode(LeadMode)
                            }

                           Toast({ messageText: "Project submitted successfully. EPC will respond as the project progresses", messageType: "S", toastId: FORMTOASTERRID });
                              
                          //  window.location.href = '/Consumer'
                          //  dispatch(setCardTitle("My Projects"));
                          //  dispatch(toggleDrawer(false));
                          //  dispatch(setTitle(""));
                          //  dispatch(resetRoofAnalisis())
                       }else{
                           setLoadingFinalProceed(false)
                           dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
                          //  Toast({ messageText: "Failed to change installation mode!", messageType: "E", toastId: FORMTOASTERRID });
                      }
                     } catch (error) {
                        setLoadingFinalProceed(false)
                        dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
                        Toast({ messageText: "Failed to change installation mode!", messageType: "E", toastId: FORMTOASTERRID });
                     }


                 } else {
                     Toast({ messageText: "Something went wrong!", messageType: "E", toastId: FORMTOASTERRID });
                     window.location.href = "/Consumer"
                     dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
                 }
             } else {
                 // setIsConfimModal(false);
                 toast.error("Please select an option for proceeding", { toastId: "abc",autoClose: 7000 });
                //  window.location.href = "/Consumer"
                 dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
             }
     };

      const handleCloseConfirm =  ()=>{
           dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"",isheader:false }));
           dispatch(setSelectedOption(""))
           setIsAnalysis(false)
           dispatch(setButtonLoader(""))
          //  setAnalysisConfirm(false)
     }

       const ConfirmModalContent = () => {
        return (
          <>
          <div className="modal-content_subscribe text-gray-600">

         
            <section className="">
              <div className="section-one_body">
                <h1 className="heading heading-md text-gray-900">Get a clear 3D view of your roof for smarter solar planning.</h1>
                <div className="section-content para para-sm">
                  <p>
                    Maximize panel efficiency, avoid installation issues, and get personalized energy and ROI estimates.
                    Here's how 3D Analysis helps:
                  </p>
                  <ul className="!list-disc" style={{ listStyle: "disc !important", paddingLeft: "1.5em" }}>
                    {/* <li>Accurate roof boundaries & parapet detection</li>
                    <li>Slope and area measurements</li> */}
                      <li>Detect accurate roof boundaries & parapet walls</li>
                      <li>Measure slope, usable area & shading</li>
                      <li>Identify and avoid installation keepouts</li>
                      <li>Place panels for max energy & ROI</li>
                  </ul>
                </div>
              </div>
            </section>
            <section>
              <div className="section-two_body">
                <h1 className="heading heading-md text-gray-900">
  One-time payment for 3D Roof Analysis
</h1>
<div className="section-content para para-sm">
  <p>
    The final price and currency are calculated when you proceed to payment.
    No ongoing fees.
  </p>
</div>
              </div>
            </section>
            </div>
          </>
        );
      };

      const [leadFinalModal,setLeadFinalModal] = useState(false);
      const [leadMode,setLeadMode] = useState<ModeOptionTy>("pvNXT Mode");

      const onGoToDashboard = () => {
        setLeadFinalModal(false)
        navigate("/Consumer")
      }

      

      
//  console.log("Secondary button  ==>> ",secondaryBtnTxt)

  return (
    <>
      {btnTxt === "Proceed To Payment" && <NewModal onSecondaryClick={handleCloseConfirm} name={"Upgrade to 3D Roof Analysis"} isLoading={isAnalysis || proceedToPaymentLoading} modalSize='lg' btnName={"Proceed To Payment"} onClick={() => confirmPaymentFor3DAnalysis("Proceed To Payment")} isAbleCLick={true} children={ConfirmModalContent()??<></>} outerClickClose  setIsCLose={handleCloseConfirm} />}
      {modalid === "finalproject" && <NewModal isFooterRequired={false} capitalizeTitle={false} modalSize={"mdlg"} isLoading={loadingFinalProceed} name={"Big sun, big savings"} btnName={"Button Name"} maxheight="fit-content" onClick={()=>{}} isAbleCLick={true} children={<ConfirmLead isLoading={loadingFinalProceed} onProceed={handleModalClick} />} setIsCLose={handleCloseConfirm} />}
      {modalid === "installationmodetopvnxt" && <NewModal isFooterRequired={false} modalSize={"lg"} isLoading={loadingFinalProceed} name={"Big sun, big savings"} btnName={"Button Name"} maxheight="fit-content" onClick={()=>{}} isAbleCLick={true} children={<ConfirmLead isLoading={loadingFinalProceed} onProceed={handleModalClick} isinstallationmodechange />} setIsCLose={handleCloseConfirm} />}
    
      {leadFinalModal && < LeadSuccessModal mode={leadMode} handleClose={setLeadFinalModal} onGoToDashboard={onGoToDashboard}/>} 
         
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"electricityrateTooltip"} content={showMoreToolTip.electricityratetooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"environmentalTooltip"} content={showMoreToolTip.environmentalTooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"costofprojecttooltip"} content={showMoreToolTip.costofprojecttooltip} />
      <ReactToolTip className="max-w-[25vw] obs" isClickable Side="LSB" place="right" id={"totalgenerationtooltip"} content={showMoreToolTip.totalgenerationtooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"financialsavingstooltip"} content={showMoreToolTip.financialsavingstooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"userdetailstooltip"} content={showMoreToolTip.userdetailstooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"userdetailstickettooltip"} content={showMoreToolTip.userdetailstickettooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"projectSummaryTooltip"} content={showMoreToolTip.projectSummaryTooltip} />
      <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="top" id={"approveProposalTooltip"} content={showMoreToolTip.approveProposalTooltip} />
      {/* <ReactToolTip className="max-w-[25vw]" isClickable Side="LSB" place="right" id={"useableareaTooltip"} content={showMoreToolTip.roofdetailstickettooltip} /> */}
      
      <div className="flex flex-col h-screen overflow-hidden">
        {/* <header className={`sticky top-0 border-b border-gray-200 z-[10] ${modalTitle ? "after:bg-black/50 before:h-full before:w-full" : ""}   `}>
          <DefaultHeader />
        </header> */}
        {/* <header className={` top-0 z-[10] border-b border-gray-200 relative ${ modalTitle && !isheader ? "before:content-[''] before:absolute before:inset-0 before:bg-black/50 before:z-10  border-black/50 border-gray-500 "  : "" }`}  > */}
        <header className={` top-0 z-[10] border-b border-gray-200 relative   `}  >
           <DefaultHeader />
         </header>
        {/* {((user && user?.projects?.length === 0) && !loading) && <CustomerDashboardLanding />} */}
        {
          // user && (user?.projects?.length === 0) &&
          (<div className="">
            <div className="flex h-full">
              <div className={`${location.pathname === "/Consumer/RoofAnalysis" || location.pathname === "/Consumer/welcome" ? "hidden" : ""}`}>
                <DefaultAside />
              </div>
              {/* aside here  */}
              <main className={`grow flex w-full  ${location.pathname === "/Consumer/project_dashboard" ? "h-full" : location.pathname === "/Consumer/RoofAnalysis" ? "h-[calc(100vh-92px)]" : "h-[calc(100vh-72px)]"}  bg-[#f1f5f9]`}>
                <section className="grow w-auto overflow-hidden">
                  <Suspense fallback={<LoadingSpinner />}>
                    {/* On reload the user isn't loaded yet: wait for the header's account check before running any page,
                        so a deleted account is logged out instead of using the app. A failed check (5xx/network) still opens it */}
                    {isVerifyingAccount ? <LoadingSpinner /> : <ErrorBoundary><Outlet /></ErrorBoundary>}
                  </Suspense>
                </section>
              </main>
            </div>
            {pathname.includes('/RoofAnalysis') && <footer className="sticky bottom-0 flex items-center bg-gray-100 w-full h-5">
              <Footer />
            </footer>}
          </div>)
        }
      </div >
    </>
  );
};

const DefaultProtectedContainer: React.FC<any> = () => {
  // console.log("update18-04")
  console.log("update-30-05")
  let { pathname } = useLocation(), allowedRoles = ["Consumer"] as userRole[];
  const auth: AuthState = getAuthState();
  const userRole = auth?.user?.role;
  if (!auth.isAuthenticated || !userRole) {
    localStorage.clear();
    return <Navigate to="/" />;
  }
  if (!pathname.startsWith(`/${userRole}`)) {
    allowedRoles = [];
  }
  if (!allowedRoles.includes(userRole!)) {
    return <Navigate to="/Consumer" />;
  }
  return <DefaultContainer pathname={pathname} />
};

export default DefaultProtectedContainer;



//  const handleModalClick = async (title: string) => { // finalizing project modal 
//          if (modalTitle === "Confirm The Action" && title == "Confirm The Action") {
//              if (selectedOption) {
//                  if (selectedOption === "Yes" && subsequentOption === undefined) {
//                      toast.error('Please select the Mode first', { toastId: "customID",autoClose: 7000 })
//                      return;
//                  }else if (selectedOption === "No") {
//                    window.location.href = "/Consumer"
//                  dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
//                  return;
//                  }

//                  setLoadingFinalProceed(true)
//                  if (selected_project && Object.keys(selected_project).length > 0) {
//                      let reqBody = {
//                          installationmode: subsequentOption === undefined ? null : subsequentOption,
//                          iscompleted: true,
//                          userid: user.userid,
//                          carbonemission: projectSummary?.financial?.totalCarbonfootprint.toString(),
//                          totaltreesplanted: projectSummary?.financial?.totalTrees.toString(),
//                          projectcost: quickplantAnalysis.costbracket.toString(),
//                          yearlygenusablearea: quickplantAnalysis.electricityGenerated?.toString(),
//                          yearlygensanctioned: quickplantAnalysis.electricityGenerated2?.toString(),
//                          plantcapacity: projectSetup?.plantcapacity ?? 0,
//                          maxplantcapacity: projectSetup?.plantcapacity ?? 0,
//                          consumer_projectstatus: 2,
//                          savingperiod : (projectSummary?.degradation?.savingperiod ?? 0) + "",
//                          savingirr : Math.floor(projectSummary?.degradation?.irr ?? 0) + "",
//                          netsavings : Math.floor(projectSummary?.degradation?.netsavings ?? 0) ,
//                          monthlyfinancialsavings : Math.floor(projectSummary?.financial?.montlyFinancialSaving ?? 0) + ""
//                      } as any;
//                     //  if (globalLayers.degradation) {
//                     //      reqBody.savingperiod = globalLayers.degradation.savingperiod.toString();
//                     //      reqBody.savingirr = globalLayers.degradation.irr.toString();
//                     //      reqBody.netsavings = globalLayers.degradation.netsavings;
//                     //  }
//                     //  if (globalLayers.financial) {
//                     //      reqBody.monthlyfinancialsavings = globalLayers.financial.montlyFinancialSaving.toString();
//                     //  }
//                      const consumerDetails = selected_project?.consumerdetails && typeof selected_project.consumerdetails === 'string' ? JSON.parse(selected_project.consumerdetails) : selected_project?.consumerdetails || {};
 
//                      if (selected_project && selected_project.consumerdetails) {
//                          reqBody.consumerdetails = JSON.stringify({
//                              ...consumerDetails,
//                              ...reqBody,
//                          });
//                      } else {
//                          reqBody.consumerdetails = JSON.stringify(reqBody);
//                      }
//                      const { payload } = await dispatch(saveConsumerProjects({ reqBody, projectid: selected_project.projectid }));
//                      if (payload) {
//                          //  navigate("/Consumer");
//                          setLoadingFinalProceed(false)
//                          dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
//                          window.location.href = '/Consumer'
//                          dispatch(setCardTitle("My Projects"));
//                          dispatch(toggleDrawer(false));
//                          dispatch(setTitle(""));
//                          dispatch(resetRoofAnalisis())
//                      }
//                  } else {
//                      Toast({ messageText: "Something went wrong!", messageType: "E", toastId: FORMTOASTERRID });
//                      window.location.href = "/Consumer"
//                      dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
//                  }
//              } else {
//                  // setIsConfimModal(false);
//                  toast.error("Please select an option for proceeding", { toastId: "abc",autoClose: 7000 });
//                 //  window.location.href = "/Consumer"
//                  dispatch(setModalHeaderFooter({ title: "", btnTxt: "", secondaryBtnTxt: "",modalid:"" }));
//              }
//          }
//      };
